import { name } from "./block.json";
import tippy from 'tippy.js';

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLDivElement) {
	const tooltipsInnerElement = block.querySelector<HTMLDivElement>('.wp-block-site-svg-tooltips__inner');
	const tooltipsString = tooltipsInnerElement?.dataset.tooltips;
	const tooltips = tooltipsString ? JSON.parse(tooltipsString) : [];

	tooltips.forEach(function(tooltip) {
		const element = block.querySelector<HTMLDivElement>(tooltip.selector);

		if (!element) {
			return;
		}

		element.classList.add('tooltip-button');

		tippy(element, {
			content: tooltip.content,
			theme: 'dark',
			arrow: true,
			allowHTML: true,
			delay: [0, 0],
			trigger: 'mouseenter focus click',
			hideOnClick: true,
			interactive: false,
			maxWidth: 650,
			animation: 'shift-away',
		});
	});
}
